import React from 'react';
import './CSS/ServiceProcess.css';

const ServiceProcess = ({ service }) => {

  return (
    <section className="service-process">
      <div className="container">
        <div className="service-process-content">
          <div className="service-process-header">
            <h2 className="service-process-title">
              Our Seamless <span className="text-primary">Process</span>
            </h2>
            <p className="service-process-description">
              We follow a clear, step-by-step approach, ensuring every service is done right
              — from assessment to final handover.
            </p>
          </div>

          <div className="process-grid">
            {service.process_steps.map((step, index) => (
              <div key={index} className={`process-item ${index % 2 === 0 ? 'top-card' : 'bottom-card'}`}>
                <div className="process-button">
                  Step {index + 1}
                </div>
                <div className="process-card">
                  <h3 className="process-card-title">{step.title}</h3>
                  <p className="process-card-description">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceProcess;